import { __decorate } from '../../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { isSameOrigin } from '../../../utilities/backend-helpers/index.js';
import '../../../atoms/buttons/enums.js';
import { isLink, getLinkURL, isRTL } from '../../../utilities/dom-helpers/index.js';
import { CategoryTileSmall } from '../../category-tile-small/index.js';
import { MainCategoriesItem } from '../../main-categories/main-categories-item.js';
import css_248z from './external-link.scss.js';

class ExternalLink extends s {
    constructor() {
        super(...arguments);
        this.modal = null;
        this.hostList = [];
        this.okBtn = null;
        this.cancelBtn = null;
        this.url = '';
        this.popupData = null;
        this.rtl = false;
    }
    setPopupData() {
        var _a;
        const externalPopupDiv = document.querySelector('[data-external-popup]');
        const externalPopupData = externalPopupDiv === null || externalPopupDiv === void 0 ? void 0 : externalPopupDiv.getAttribute('data-external-popup');
        const okBtnSlot = this.shadowRoot.querySelector('slot[name=primary-cta]');
        this.okBtn = okBtnSlot.assignedElements()[0];
        const cancelBtnSlot = this.shadowRoot.querySelector('slot[name=secondary-cta]');
        this.cancelBtn = cancelBtnSlot.assignedElements()[0];
        this.popupData = (externalPopupData === null || externalPopupData === void 0 ? void 0 : externalPopupData.length) && JSON.parse(externalPopupData);
        this.hostList = (_a = this.popupData) === null || _a === void 0 ? void 0 : _a.hosts;
    }
    isUrlInHostlist(url, hostlist = this.hostList) {
        return hostlist.find(host => {
            if (host.startsWith('http')) {
                try {
                    const hostURL = new URL(host);
                    return hostURL.hostname === url.hostname;
                }
                catch (_a) {
                    return false;
                }
            }
            else {
                return url.hostname.indexOf(host) > -1;
            }
        });
    }
    isUrlInternalSite(urlToCheck) {
        try {
            const baseUrl = new URL(document.baseURI);
            const url = new URL(urlToCheck, document.baseURI);
            if (url.hostname === baseUrl.hostname) {
                return false;
            }
            if (this.isUrlInHostlist(url)) {
                return true;
            }
        }
        catch (_a) {
            return false;
        }
        return false;
    }
    redirectOnOkClick(capture = false) {
        const clickEvent = (e) => {
            e.stopPropagation();
            this.modal.hideModal();
            if (this.url)
                window.open(this.url, '_blank');
        };
        if (this.okBtn) {
            const clonedOkBtn = this.okBtn.cloneNode(true);
            this.okBtn.parentNode.replaceChild(clonedOkBtn, this.okBtn);
            this.okBtn = clonedOkBtn;
            clonedOkBtn.addEventListener('click', e => clickEvent(e), capture);
        }
    }
    handleClick(e, capture) {
        var _a;
        e.stopPropagation();
        const target = e.target;
        const webComponentTarget = e.composedPath()[0];
        const contextToCheck = [CategoryTileSmall, MainCategoriesItem];
        // Early return if the click target is a button, select, or input
        if (target instanceof HTMLButtonElement ||
            target instanceof HTMLSelectElement ||
            target instanceof HTMLInputElement ||
            webComponentTarget instanceof HTMLButtonElement ||
            webComponentTarget instanceof HTMLSelectElement ||
            webComponentTarget instanceof HTMLInputElement) {
            return;
        }
        if (!isLink(target, contextToCheck) ||
            !isLink(webComponentTarget, contextToCheck))
            return;
        this.url = getLinkURL(target);
        if (isLink(webComponentTarget, contextToCheck)) {
            this.url = getLinkURL(webComponentTarget);
        }
        if ((target === null || target === void 0 ? void 0 : target.parentNode) instanceof CategoryTileSmall ||
            (target === null || target === void 0 ? void 0 : target.parentNode) instanceof MainCategoriesItem) {
            this.url = target === null || target === void 0 ? void 0 : target.parentNode.href;
        }
        if (this.url) {
            const url = new URL(this.url);
            if (url.pathname === 'void(0)' ||
                url.href.startsWith('mailto:') ||
                url.href.startsWith('tel:'))
                return;
        }
        if (this.url && isSameOrigin(this.url))
            return;
        if (this.isUrlInternalSite(this.url)) {
            if (!this.url)
                return;
            window.location.href = this.url;
            return;
        }
        e.preventDefault();
        this.redirectOnOkClick(capture);
        (_a = this.modal) === null || _a === void 0 ? void 0 : _a.showModal();
        window.CVTModalTargetElement = webComponentTarget;
    }
    addOnClickEvents(node = document, capture = false) {
        node.addEventListener('click', (e) => this.handleClick(e, capture), capture);
    }
    hideModalOnOkClick() {
        var _a;
        (_a = this.cancelBtn) === null || _a === void 0 ? void 0 : _a.addEventListener('click', () => {
            this.modal.hideModal();
        });
    }
    applyTabletStylingsToModal() {
        this.modal
            .shadowRoot.querySelector('.modal-outer')
            .classList.add('limited-width');
    }
    firstUpdated() {
        this.modal = document.querySelector('cvt-modal[popupid="external-link"]');
        if (!this.modal)
            return;
        this.applyTabletStylingsToModal();
        this.setPopupData();
        this.hideModalOnOkClick();
        this.addOnClickEvents();
    }
    render() {
        return x `<div slot="content" class="modal-content ${this.rtl || isRTL() ? 'rtl' : ''}"><slot name="heading"></slot><slot name="main-text"></slot><div class="cta-container"><slot name="primary-cta"></slot><slot name="secondary-cta"></slot></div></div>`;
    }
}
ExternalLink.styles = css_248z;
__decorate([
    t()
], ExternalLink.prototype, "modal", void 0);
__decorate([
    t()
], ExternalLink.prototype, "hostList", void 0);
__decorate([
    t()
], ExternalLink.prototype, "okBtn", void 0);
__decorate([
    t()
], ExternalLink.prototype, "cancelBtn", void 0);
__decorate([
    t()
], ExternalLink.prototype, "url", void 0);
__decorate([
    t()
], ExternalLink.prototype, "popupData", void 0);
__decorate([
    n({ type: Boolean })
], ExternalLink.prototype, "rtl", void 0);
customElements.define('external-link', ExternalLink);

export { ExternalLink };
